import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PublicRoutingModule} from './public-routing.module';
import {PublicComponent} from './public.component';
import {SharedModule} from '../shared/shared.module';
import {TrackingModule} from './tracking/tracking.module';
import {TermsComponent} from './terms/terms.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {ContactsComponent} from './contacts/contacts.component';
import {FaqComponent} from './faq/faq.component';
import {HowToAddDeliveryComponent} from './how-to-add-delivery/how-to-add-delivery.component';
import {DeliveryOptionsComponent} from './delivery-options/delivery-options.component';
import {AboutServiceComponent} from './about-service/about-service.component';
import {IntegrationComponent} from './integration/integration.component';
import {IntegratedServiceProviderComponent} from './integrated-service-provider/integrated-service-provider.component';
import {AddDeliveryComponent} from './add-delivery/add-delivery.component';
import {SearchOrderComponent} from './add-delivery/search-order/search-order.component';
import {EuropeanMoldovaComponent} from './european-moldova/european-moldova.component';

@NgModule({
   declarations: [
      PublicComponent,
      TermsComponent,
      LandingPageComponent,
      ContactsComponent,
      FaqComponent,
      HowToAddDeliveryComponent,
      DeliveryOptionsComponent,
      AboutServiceComponent,
      IntegrationComponent,
      IntegratedServiceProviderComponent,
      SearchOrderComponent,
      AddDeliveryComponent,
      EuropeanMoldovaComponent
   ],
   imports: [CommonModule, PublicRoutingModule, SharedModule, TrackingModule, TranslateModule],
})
export class PublicModule {}
